// // // base44Client.js
// // import { createClient } from '@base44/sdk';

// // export const base44 = createClient({
// //   appId: "69382c65b35506e7d2be018d",
// //   requiresAuth: false   // 👈 לבטל הפניה למסך לוגין של Base44
// // });


// // src/api/base44Client.js
// // ניתקנו את הספרייה החיצונית. כעת זהו אובייקט מקומי בלבד.






// import axios from "axios";

// // הכתובת של השרת המקומי שלך
// const API_BASE = "http://localhost:5001/api"; 

// // יצירת 'שליח' שמדבר עם השרת
// const client = axios.create({
//   baseURL: API_BASE,
//   headers: { "Content-Type": "application/json" }
// });

// // הגדרה חשובה: לפני כל בקשה לשרת, תוסיף את הטוקן של המשתמש
// client.interceptors.request.use((config) => {
//   const token = localStorage.getItem("auth_token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// // המיפוי: כאן אנחנו אומרים למערכת לאן לפנות עבור כל סוג מידע
// export const base44 = {
//   auth: {
//     // פונקציית התנתקות
//     logout: () => {
//       localStorage.removeItem("auth_token");
//       localStorage.removeItem("app_user");
//       window.location.href = "/login";
//     }
//   },
  
//   entities: {
//     // === כאן החיבור האמיתי למשתמשים ===
//     User: {
//       // קבלת כל המשתמשים: GET /api/users
//       list: async () => { 
//         try {
//           const res = await client.get("/users"); 
//           return res.data; 
//         } catch (e) { return []; }
//       },
//       // יצירת משתמש חדש: POST /api/users
//       create: async (data) => { 
//         const res = await client.post("/users", data); 
//         return res.data; 
//       },
//       // עדכון משתמש: PUT /api/users/:id
//       update: async (id, data) => { 
//         const res = await client.put(`/users/${id}`, data); 
//         return res.data; 
//       },
//       // סינון (כרגע נשאיר ריק למניעת תקלות)
//       filter: async () => [] 
//     },


//     UserRole: {
//       list: async () => { 
//         const res = await client.get("/roles"); 
//         return res.data; 
//       },
//       create: async (data) => { 
//         const res = await client.post("/roles", data); 
//         return res.data; 
//       },
//       update: async (id, data) => { 
//         const res = await client.put(`/roles/${id}`, data); 
//         return res.data; 
//       }
//     },



//     // === כל השאר נשארים "דמה" (ריקים) כדי לא לשבור את האתר ===
//     // ברגע שתבנה בשרת את storeController, נחבר גם את זה באותה צורה
//     Store: { list: async () => [] },
//     Chain: { list: async () => [] },
//     Product: { list: async () => [], filter: async () => [] },
//     Category: { list: async () => [] },
//     Company: { list: async () => [] },
//     Supplier: { list: async () => [] },
//     InventoryCount: { list: async () => [], filter: async () => [] },
//     ServiceRequest: { list: async () => [] },
//     Return: { list: async () => [] },
//     Destruction: { list: async () => [] },
//     MustOrderTask: { list: async () => [] },
//     SafeCount: { list: async () => [] },
//     SearchHistory: { filter: async () => [] },
//     Notification: { list: async () => [] },
//     Brochure: { list: async () => [] },
//     Promotion: { list: async () => [] },
//     Order: { list: async () => [] },
//     PromotionImplementation: { list: async () => [] }
//   }
// };







import axios from "axios";
import { getApiBaseUrl } from "@/lib/apiBase";
import { asArray } from "@/lib/asArray";
import { readAuthToken, clearAuthStorage } from "@/lib/authStorage";

// const API_BASE = import.meta.env.MODE === 'development'
//   ? "http://localhost:5001"
//   : "https://api.reshet.app";

const API_BASE = getApiBaseUrl();




const client = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 15000 // העליתי ל-5 שניות ליתר ביטחון
});

client.interceptors.request.use((config) => {
  const token = readAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// פונקציית עזר למניעת קריסות למודולים שעוד לא בנינו
const emptyMock = {
  list: async () => [],
  get: async () => ({}),
  filter: async () => [],
  create: async () => ({}),
  update: async () => ({}),
  delete: async () => ({})
};


// פונקציית עזר לקיצור קוד (יוצרת אוטומטית list, get, create, update, delete)
const createCrudEndpoints = (endpoint) => ({
  list: async (params = {}) => {
    try {
      const res = await client.get(endpoint, { params });
      return asArray(res.data);
    } catch (e) {
      return [];
    }
  },
  get: async (id) => {
    const res = await client.get(`${endpoint}/${id}`);
    return res.data;
  },
  create: async (data) => {
    const res = await client.post(endpoint, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await client.put(`${endpoint}/${id}`, data);
    return res.data;
  },
  delete: async (id) => {
    const res = await client.delete(`${endpoint}/${id}`);
    return res.data;
  }
});


export const base44 = {
  auth: {
    me: async () => {
      const res = await client.get("/auth/me");
      return res.data;
    },
    /** קוד SMS לאזור נתונים קריטיים (משתמש מחובר + הרשאה בפרופיל) */
    requestCriticalDataSms: async () => {
      const res = await client.post("/auth/critical-data/request-sms");
      return res.data;
    },
    verifyCriticalDataSms: async (code) => {
      const res = await client.post("/auth/critical-data/verify", { code });
      return res.data;
    },
    logout: () => {
      clearAuthStorage();
      if (typeof navigator !== "undefined" && navigator.onLine) {
        window.location.href = "/login";
      }
    }
  },

  /** סנכרון נתונים (שרת) */
  dataSync: {
    syncComaxCustomers: async () => {
      /** סנכרון קומקס: הורדת XML + פרסור — חייב להיות גבוה מ-timeout של axios בשרת (COMAX_SOAP_TIMEOUT_MS) */
      const res = await client.post("/data-sync/comax-customers", {}, { timeout: 900000 });
      return res.data;
    },
  },
  
  // אינטגרציות (למשל העלאת קבצים)
  integrations: {
    Core: {
       // אם עדיין אין לך ראוט להעלאת קבצים כללית, נשתמש בזה של ה-Chains או ניצור חדש
       // כרגע אני משתמש בנתיב כללי, אם אין לך אותו תגיד לי וניצור
       UploadFile: async ({ file, folder = 'logos' }) => {
        const formData = new FormData();
        
        // חשוב מאוד: הוספת ה-folder לפני ה-file!
        formData.append("folder", folder); 
        formData.append("file", file);
      
        const res = await client.post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        return res.data;
      }
    }
  },

  entities: {
    // משתמשים ותפקידים
    User: {
      list: async () => {
        try {
          const res = await client.get("/users");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      create: async (data) => { const res = await client.post("/users", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/users/${id}`, data); return res.data; },
      filter: async () => [] 
    },
    UserRole: {
      list: async () => {
        try {
          const res = await client.get("/roles");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      create: async (data) => { const res = await client.post("/roles", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/roles/${id}`, data); return res.data; }
    },

    // רשתות
    Chain: {
      list: async () => {
        try {
          const res = await client.get("/chains");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      create: async (data) => { 
        const res = await client.post("/chains", data, { headers: { "Content-Type": "multipart/form-data" } }); 
        return res.data; 
      },
      update: async (id, data) => { 
        const res = await client.put(`/chains/${id}`, data, { headers: { "Content-Type": "multipart/form-data" } }); 
        return res.data; 
      },
      filter: async () => []
    },

    // חנויות
    Store: {
      list: async () => {
        try {
          const res = await client.get("/stores");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      get: async (id) => { const res = await client.get(`/stores/${id}`); return res.data; },
      create: async (data) => { const res = await client.post("/stores", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/stores/${id}`, data); return res.data; },
      delete: async (id) => { const res = await client.delete(`/stores/${id}`); return res.data; },
      filter: async ({ id }) => { 
          // תמיכה ב-filter שהשתמשנו בו ב-StoreDetails
          if(id) {
             const res = await client.get(`/stores/${id}`);
             return [res.data];
          }
          return [];
      }
    },

    // --- התיקון: חיבור ספקים (Suppliers) ---
    Supplier: {
      list: async () => {
        try {
          const res = await client.get("/suppliers");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      get: async (id) => { const res = await client.get(`/suppliers/${id}`); return res.data; },
      
      // FormData – בלי Content-Type ידני כדי ש-axios יוסיף boundary (אחרת השרת לא מפרסר)
      create: async (data) => {
          const res = await client.post("/suppliers", data);
          return res.data;
      },
      update: async (id, data) => {
          const res = await client.put(`/suppliers/${id}`, data);
          return res.data;
      },

      getDeliveryInfo: async (id) => {
        const res = await client.get(`/suppliers/my-delivery-info/${id}`);
        return res.data;
      },
      
      delete: async (id) => { const res = await client.delete(`/suppliers/${id}`); return res.data; },
    },
    
    // הגדרות מערכת
    SystemSetting: {
        list: async () => {
          try {
            const res = await client.get("/settings");
            return asArray(res.data);
          } catch (e) {
            return [];
          }
        },
        update: async (key, values) => { const res = await client.put(`/settings/${key}`, { values }); return res.data; },
        init: async () => { await client.post("/settings/init"); }
    },


    ServiceRequest: {
      list: async () => { 
          try {
              const res = await client.get("/service-requests"); 
              return res.data; 
          } catch (e) { return []; } 
      },
      create: async (data) => { 
          const res = await client.post("/service-requests", data); 
          return res.data; 
      },
      update: async (id, data) => { 
          const res = await client.patch(`/service-requests/${id}`, data); 
          return res.data; 
      },
      delete: async (id) => { 
          const res = await client.delete(`/service-requests/${id}`); 
          return res.data; 
      }
  },

  ManagementTask: {
    list: async (sort = '-created_date') => {
      const res = await client.get("/management-tasks", { params: { sort } });
      return res.data;
    },
    filter: async (params) => {
      const res = await client.get("/management-tasks", { params });
      return res.data;
    },
    create: async (data) => {
      const res = await client.post("/management-tasks", data);
      return res.data;
    },
    get: async (id) => {
      const res = await client.get(`/management-tasks/${id}`);
      return res.data;
    },
    // פונקציה להשלמת משימה על ידי סניף
    complete: async (id, data) => {
      const res = await client.patch(`/management-tasks/${id}/complete`, data);
      return res.data;
    }
  },


  // בתוך entities בתוך base44Client.js
Order: {
  /** מיון לשרת — מחרוזת או { sort: '-createdAt' } (לא אובייקט store_id; הסינון הוא לפי JWT בשרת) */
  list: async (sortOrParams = "-createdAt") => {
    try {
      const sort =
        typeof sortOrParams === "string"
          ? sortOrParams
          : sortOrParams?.sort ?? "-createdAt";
      const res = await client.get("/orders", { params: { sort } });
      return res.data;
    } catch (e) {
      console.error("Error fetching orders:", e);
      return [];
    }
  },
  get: async (id) => {
    const res = await client.get(`/orders/${id}`);
    return res.data;
  },
  /** timeout ברירת מחדל ארוך — שליחה לקומקס יכולה לקחת דקות; BasicProductsReminder מעביר { timeout: 0 } ללא הגבלה */
  create: async (data, axiosConfig = {}) => {
    const res = await client.post("/orders", data, {
      timeout: 180000,
      ...axiosConfig,
    });
    return res.data;
  },
  update: async (id, data) => {
    const res = await client.put(`/orders/${id}`, data);
    return res.data;
  },
  warehousePrint: async (id) => {
    // הוספת timeout ספציפי של 30 שניות לקריאה הזו
    const res = await client.post(`/orders/${id}/reprint-warehouse`, {}, { timeout: 30000 });
    return res.data;
  },
  printDetails: async (id) => {
    const res = await client.post(`/orders/${id}/print-details`, {}, { timeout: 30000 });
    return res.data;
  },
  /** ארכיון (מחיקה רכה) – סופר אדמין + אימות מספר הזמנה */
  archive: async (id, body) => {
    const res = await client.post(`/orders/${id}/archive`, body);
    return res.data;
  },
  // פונקציית פילטר כדי למנוע שגיאות בחיפושים מסוימים
  filter: async ({ id }) => {
    if (id) {
      const res = await client.get(`/orders/${id}`);
      return [res.data];
    }
    return [];
  }
},


  Brochure: {
    list: async () => {
      try {
        const res = await client.get("/brochures");
        return asArray(res.data);
      } catch (e) {
        return [];
      }
    },
    create: async (data) => { const res = await client.post("/brochures", data); return res.data; },
    update: async (id, data) => { const res = await client.put(`/brochures/${id}`, data); return res.data; },
    delete: async (id) => { const res = await client.delete(`/brochures/${id}`); return res.data; }
},
DailySale: {
  getProductStats: async (params) => {
    // השליח client כבר מכיל את ה-Token וה-BaseURL
    const res = await client.get("/sales/product-stats", { params });
    return res.data;
  }
},
// התראות - מחובר לשרת!
Notification: {
    list: async () => {
      try {
        const res = await client.get("/notifications");
        return asArray(res.data);
      } catch (e) {
        return [];
      }
    },
    create: async (data) => { const res = await client.post("/notifications", data); return res.data; },
    update: async (id, data) => { 
      const res = await client.put(`/notifications/${id}`, data); 
      return res.data; 
  },
},



Promotion: {
  ...createCrudEndpoints("/promotions"),
  bulkImport: async (promotions) => client.post("/promotions/import", { promotions }),

  list: async () => {
    try {
      const res = await client.get("/promotions");
      return Array.isArray(res.data) ? res.data : []; // מבטיח שתמיד יחזור מערך
    } catch (e) {
      return [];
    }
  },  create: (data) => client.post("/promotions", data),
  update: (id, data) => client.put(`/promotions/${id}`, data),
  delete: (id) => client.delete(`/promotions/${id}`),

  // ✅ חדש
  send: async (data) => {
    const res = await client.post("/promotions/send", data);
    return res.data;
  },
  import: async (data) => {
    // הוספת timeout של 60 שניות לקריאה הזו
    const res = await client.post("/promotions/import", data, { timeout: 60000 });
    return res.data;
},
},



// ✅ תיקון קריטי: העברת הפרמטרים (params) לשרת
Product: {
  list: async (params = {}) => { 
      try {
        // אנחנו מעבירים את ה-params (עמוד, פילטרים וכו') לתוך בקשת ה-GET
        const res = await client.get("/products", { params }); 
        return res.data; 
      } catch (e) { return { data: [], pagination: { total: 0 } }; }
  },
  get: async (id) => { 
      const res = await client.get(`/products/${id}`); 
      return res.data; 
  },
  // listForMyStore: async (params = {}) => {
  //   try {
  //     const res = await client.get("/products/store", { params });
  //     return res.data;
  //   } catch (e) {
  //     return { data: [], pagination: { page: 1, pages: 1, total: 0 } };
  //   }
  // },

  listForMyStore: async (params = {}) => {
    // הסרנו את ה-try/catch כדי שהשגיאה תעלה ל-UI ונדע מה קורה
    const res = await client.get("/products/store", { params }); 
    return res.data;
  },
  getByCategory: async (categoryId) => {
    const res = await client.get(`/products/by-category/${categoryId}`);
    return res.data; // מחזיר מערך פשוט של מוצרים
  },
  update: async (id, data) => { 
      const res = await client.put(`/products/${id}`, data); 
      return res.data; 
  },
  delete: async (id) => { 
      const res = await client.delete(`/products/${id}`); 
      return res.data; 
  },
  sync: async () => {
    const res = await client.post("/products/sync", {}, {
      // ✅ המתנה של עד 10 דקות לפני שמוותרים על התשובה
      timeout: 600000 
  });
      return res.data;
  },
  /** @deprecated בפועל מפעיל GS1; השתמש ב-syncImagesFromDriveOnly לדרייב */
  syncImages: async () => {
    const res = await client.post("/images/sync-drive");
    return res.data;
  },
  /** תמונות מ-Google Drive בלבד (סריקה רקורסיבית, WebP ל-S3, רק מוצרים ללא תמונה) */
  syncImagesFromDriveOnly: async () => {
    const res = await client.post("/images/sync-from-drive", {}, { timeout: 600000 });
    return res.data;
  },
  /** תמונות מ-GS1 בלבד (רק מוצרים ללא תמונה — אותה שאילתה כמו דרייב) */
  syncImagesFromGS1Only: async () => {
    const res = await client.post("/images/sync-from-gs1", {}, { timeout: 600000 });
    return res.data;
  },
  syncImagesFull: async () => {
    const res = await client.post("/images/sync-full", {}, { timeout: 600000 });
    return res.data;
  },
getRelated: async (params) => {
  const res = await client.get("/products/related", { params });
  return res.data;
},
/** המוצרים הבאים בסדר באותה תת־תת־קטגוריה (מעגלית) */
getNextInSubSub: async (params) => {
  const res = await client.get("/products/next-in-subsub", { params });
  return Array.isArray(res.data) ? res.data : [];
},
searchInStore: async (params = {}) => {
  try {
    const res = await client.get("/products/search/my-store", { params });
    return res.data;
  } catch (e) {
    return { data: [], pagination: { total: 0 } };
  }
},
export: async (params = {}) => {
  // responseType: 'blob' הכרחי כדי שהדפדפן יזהה שזה קובץ להורדה
  const res = await client.get("/products/export", { params, responseType: 'blob' });
  return res;
},
bulkUpdate: async (filters, updateData) => {
  const res = await client.post("/products/bulk-update", { filters, updateData });
  return res.data;
},
/** סדר מוצרים לפי חברה או תת־תת־קטגוריה — בקשה אחת (bulkWrite בשרת) */
reorderDisplayOrder: async ({ kind, scopeId, orderedProductIds }) => {
  const res = await client.post(
    "/products/reorder-display-order",
    { kind, scopeId, orderedProductIds },
    { timeout: 120000 }
  );
  return res.data;
},
  filter: async () => [] 
},

Recommendation: {
  listSuppliers: async () => { 
      try { 
          const res = await client.get("/recommendations/suppliers"); 
          return res.data; 
      } catch (e) { return []; } 
  }
},


Category: createCrudEndpoints("/categories"),
SubCategory: createCrudEndpoints("/subcategories"),
SubSubCategory: createCrudEndpoints("/subsubcategories"),
Company: createCrudEndpoints("/companies"),



    Return: emptyMock,
    Destruction: emptyMock,
    // Promotion: emptyMock,
    // Brochure: emptyMock,
    InventoryCount: emptyMock,
    // Notification: emptyMock,

    
    CartItem: {
      getAdminAllData: async () => {
        try {
          const res = await client.get("/cart/admin-all-data");
          return res.data;
        } catch (e) {
          console.error("Error fetching admin data:", e);
          return { cartItems: [], stores: [], chains: [], products: [], suppliers: [] };
        }
      },
      filter: async (params = {}) => {
        const res = await client.get("/cart", { params });
        return asArray(res.data);
      },
      create: async (data) => {
        const res = await client.post("/cart", data);
        return res.data;
      },
      list: async (params = {}) => {
        const res = await client.get("/cart", { params });
        return asArray(res.data);
      },
      update: async (data) => {
        const res = await client.post("/cart", data); 
        return res.data;
      },
      getAdminSummary: async () => {
        const res = await client.get("/cart/admin-all-data");
        return res.data;
      },
      duplicateOrder: async (data) => {
        const res = await client.post("/cart/duplicate", data); 
        return res.data;
      },
      delete: async (id) => {
        const res = await client.delete(`/cart/${id}`);
        return res.data;
      }
    },


    PromotionImplementation: {
      list: async () => {
        try {
          const res = await client.get("/implementations");
          return asArray(res.data);
        } catch (e) {
          return [];
        }
      },
      update: async (id, data) => {
        // שליחת הוכחת הטמעה (צילום)
        const res = await client.post("/implementations", {
          promotion_id: data.promotion_id || id,
          proof_image_url: data.proof_image_url
        });
        return res.data;
      },
      approve: async (id) => {
        const res = await client.patch(`/implementations/${id}/approve`);
        return res.data;
      }
    },

    // בתוך base44Client.js תחת entities:

MustOrderTask: {
  list: async () => {
    try {
      const res = await client.get("/must-order-tasks");
      return asArray(res.data);
    } catch (e) {
      return [];
    }
  },
  filter: async (params) => {
    try {
      const res = await client.get("/must-order-tasks", { params });
      return asArray(res.data);
    } catch (e) {
      return [];
    }
  },
  create: async (data) => { 
    const res = await client.post("/must-order-tasks", data); 
    return res.data; 
  },
  update: async (id, data) => { 
    const res = await client.put(`/must-order-tasks/${id}`, data); 
    return res.data; 
  },
  delete: async (id) => { 
    const res = await client.delete(`/must-order-tasks/${id}`); 
    return res.data; 
  }
},

// בנוסף, וודא שגם Order מחובר לשרת:
// Order: createCrudEndpoints("/orders"),    
SearchHistory: emptyMock,
    SafeCount: emptyMock,
    
    
  }
};